module.exports = __webpack_public_path__ + "img/SKMJ_evaluation1.660aded0.png";